import Storage from '../Storage.js';

Storage.setTranslations("ru", {

  menu_exit: "Выход",

  title_create: "Создание",
  title_edit: "Редактирование",
  title_view: "Просмотр",
  
  button_search: "Поиск",
  button_edit: "Править",
  button_delete: "Удалить",
  button_add: "Добавить",
  button_save: "Сохранить",
  button_deleted: "Удалено",
  button_close: "Закрыть",
  button_cancel: "Отмена",

  page_previous: "пред.",
  page_next: "след.",
  page_placeholder: "номер",
  page_go: "перейти",

  input_select: "Выбрать...",
  input_enter: "Введите имя...",
  
  display_yes: "да",
  display_no: "нет",

  modal_response_title: "Ответ от сервера",
  modal_response_link: "Ссылка для скачивания",
  modal_delete_title: "УДАЛЕНИЕ",
  modal_delete_text: "Вы действительно собираетесь удалить ",
  
});


// WEBPACK FOOTER //
// ./src/translations/ru.js